export const urlGetAllPermissions = `/it-manager/permissions-grouped`;
export const urlGetRoles = `/it-manager/roles`;
